module.exports = {"140427100":"龙泉镇","140427101":"百尺镇","140427102":"店上镇","140427103":"晋庄镇","140427104":"树掌镇","140427200":"集店乡","140427201":"黄山乡","140427202":"东井岭乡","140427203":"石坡乡","140427204":"五龙山乡","140427205":"鹅屋乡","140427206":"桥上乡","140427400":"常平经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140427.json
// module id = 263
// module chunks = 0